import { render, staticRenderFns } from "./SourceInput.vue?vue&type=template&id=2f5710d0&scoped=true&"
import script from "./SourceInput.vue?vue&type=script&lang=js&"
export * from "./SourceInput.vue?vue&type=script&lang=js&"
import style0 from "./SourceInput.vue?vue&type=style&index=0&id=2f5710d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5710d0",
  null
  
)

export default component.exports